import type { FetchResponse } from 'openapi-fetch';
import type { SuccessResponse } from 'openapi-typescript-helpers';
import type { paths } from './coreApiSchema';
import { getItem } from '../utils/storage';
import { getLegacyUserTenants } from './legacyOrganizations';
import { isMultiOrgFeatureEnabled, shouldUseCoreApi } from '../utils/features';
import { API_VERSION } from '../config/app';
import { coreApiClient } from './apiClient';

type GetTenantsSuccessResponse = SuccessResponse<paths['/core/v1/tenants']['get']['responses']>;
type GetTenantsResponse = FetchResponse<
  paths['/core/v1/tenants']['get'],
  GetTenantsSuccessResponse,
  'application/json'
>;
export type Tenant = GetTenantsSuccessResponse['data'][number];

export const getTenants = (): Promise<GetTenantsResponse> => {
  if (!shouldUseCoreApi() && !isMultiOrgFeatureEnabled()) {
    return getLegacyUserTenants();
  }

  return coreApiClient.GET('/core/v1/tenants', {
    params: {
      header: {
        authorization: `Bearer ${getItem('coreApiAccessToken')}`,
        'cosafe-api-version': String(API_VERSION),
      },
    },
  });
};
